/**
 * Ajuda dos campos das telas do P-PAR-4 dentro da parametrizacao: Perfil da
 * Corretora, Consultas PJ e Pre-validacao e Bureaus por tipo de consulta; e, do
 * P-PAR-3, as do endosso de aniversario e da renovacao, com as rotas do menu delas.
 *
 * As telas abrem pelos cartoes de `/parametrizacao` e ficam abaixo dela, e por isso a
 * chave e a rota do menu. O arquivo leva o nome do modulo do backend (`parameters`),
 * como `resources/parameters.ts`, para nao disputar o arquivo da parametrizacao de
 * modalidades. Juntada em `../ajudaDosCampos.ts`. Ver docs/FRONTEND.md, secao 6.
 */

export const ajuda: Record<string, Record<string, string>> = {
  '/parametrizacao': {
    'Home menu':
      'Tela que abre quando a pessoa com este perfil entra. So aparecem as telas do menu da corretora que as caixas marcadas alcancam.',
    Bureau:
      'Bureau do catalogo de provedores usado por este tipo de consulta. So entram bureaus de credito ou cadastrais.',
    'Usuario de acesso':
      'Login da empresa no bureau. Fica gravado e aparece para quem le a tela.',
    'Segredo de acesso':
      'Senha ou chave do bureau. E guardado cifrado e nunca volta para a tela. Deixe em branco para manter o que esta gravado.',
    'Observacao da versao':
      'Nota da versao do rascunho, gravada com ela e no historico de alteracoes.',
    'Justificativa da ativacao':
      'Obrigatoria. Diz por que a versao entra em vigor; fica na versao e no historico.',
    'Nome do tipo de consulta':
      'Nome do tipo de consulta a bureau da empresa, como Consulta PJ. Ate 120 caracteres.',
    'Tipo de chamada':
      'O tipo de chamada que a consulta produz no registro de integracoes. So entram os da familia bureau.',
    Prioridade:
      'Ordem do bureau no tipo de consulta, de 1 a 99, sem repetir. Ainda nao escolhe o bureau consultado.',
    'Ordem de exibicao': 'Posicao do tipo de consulta na lista, de 0 a 10000.',
  },
  // P-PAR-3: endosso de aniversario. Parametro guardado com versao, sem rotina.
  '/parametrizacao/endosso': {
    'Notificacao previa do aniversario (dias)':
      'Dias antes do aniversario da apolice em que o aviso sairia. Guardado sem efeito: nenhum aviso e enviado ate a homologacao (END-007).',
    'Vencimento do boleto do endosso (dias)':
      'Prazo do boleto do endosso de aniversario, em dias. A unidade e a base da contagem estao a confirmar com a seguradora. Guardado sem efeito.',
    'Taxa usada no endosso':
      'Taxa que o endosso de aniversario usaria. So a taxa da apolice esta documentada, e nenhum premio e calculado (PRC-009).',
    'Titulo do email de aviso':
      'Assunto do e-mail de aviso, com ate 200 caracteres. Aceita TAGs do e-mail, como {{apolice.numero}}. Obrigatorio para ativar a versao.',
    'Mensagem do email de aviso':
      'Texto do e-mail de aviso, com as TAGs do e-mail. O texto e saneado no servidor e o envio fica desligado ate a homologacao (EMI-002).',
    'Descricao do Objeto do Endosso':
      'Texto do objeto do endosso de aniversario, com as TAGs do objeto. Obrigatorio para ativar a versao; nenhum objeto e montado ainda (END-008).',
    Modalidade:
      'Modalidade com endosso de aniversario. Cada modalidade tem um parametro so na empresa; para mudar, edite o dela.',
    'Tipo de Indice':
      'Indice de reajuste do catalogo da plataforma. Fica guardado; nenhum reajuste e calculado ate a formula ser homologada (F-14).',
  },
  // P-PAR-3: renovacao de apolices. Parametro guardado com versao, sem rotina.
  '/parametrizacao/renovacao': {
    'Titulo do email de aviso':
      'Assunto do e-mail de aviso de renovacao, com ate 200 caracteres. Aceita TAGs do e-mail, como {{apolice.numero}}. Obrigatorio para ativar.',
    'Mensagem do email de aviso':
      'Texto do e-mail aos perfis da corretora marcados, com as TAGs do e-mail. O envio fica desligado ate a homologacao (REN-002, EMI-002).',
    'Vencimento do boleto da renovacao (dias)':
      'Dias a partir do inicio de vigencia da renovada (a confirmar). Guardado sem efeito.',
    Modalidade:
      'Modalidade com parametro de renovacao. Cada modalidade tem um parametro so na empresa; para mudar, edite o dela.',
    'Prazo maximo de vigencia (dias)':
      'Prazo maximo da apolice renovada, em dias. Em branco mantem o prazo da apolice original. Guardado sem efeito.',
    'Prazo para criacao da cotacao (dias)':
      'Dias antes do fim da vigencia. Na versao em vigor, e a janela da modalidade na fila de Renovacoes; nenhuma cotacao e criada sozinha.',
    'Prazo (em dias) para cancelamento automatico da apolice, apos o fim da vigencia':
      'Guardado sem rotina: o cancelamento automatico fica bloqueado ate a decisao juridica (PJ-01).',
    'Prazo para emissao da apolice (dias)':
      'Prazo para emitir a apolice renovada, em dias. Guardado sem efeito: nenhuma apolice e emitida automaticamente.',
    'Indice de reajuste da importancia segurada':
      'Indice do catalogo da plataforma. Fica guardado; nenhum reajuste e calculado ate a formula ser homologada (F-14, F-18).',
  },
};
